module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraBold.91d69107.woff2";